import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Box, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import * as yup from "yup";
import { environment } from "../../../../environments/environment";
import { RootState } from "../../../../redux";
import AutocompleteSelect from "../../../../ui/components/autocomplete-select/autocomplete-select";
import CustomInput from "../../../../ui/components/custom-input/custom-input";
import CustomModal from "../../../../ui/components/custom-modal/custom-modal";
import CustomSelect from "../../../../ui/components/custom-select/custom-select";
import { UserInfo } from "../../../../ui/models/userInfo";
import { ConvenioPractica } from "../../../models/convenio-practica";
import { ListModel } from "../../../models/list-model";
import { PracticaSempre } from "../../../models/practica-sempre";
import { PrecargaSempreList } from "../../../models/precarga-sempre-list";
import { convenioServices } from "../../../services/convenio.services";
import { importacionSempreServices } from "../../../services/importacion-sempre.services";
import { getFormattedDate, getFormattedDecimal } from "../../../utils/common.utils";
import { handle400Error } from "../../../utils/handle-400-errors";
import { formBonos } from "../../../utils/practica-sempre.utils";
import { formatPracticaDescription } from "../../../utils/practica.utils";
import "./practica-presentar.scss";

export interface PracticaPresentarModalProps {
  show: boolean;
  practica: PrecargaSempreList;
  handleClose: (success: boolean, item: any) => void;
  refetch: () => void;
}

export function PracticaPresentarModal(props: PracticaPresentarModalProps) {
  const { show, practica, handleClose, refetch } = props;
  const [formBonoSeries, setFormBonoSeries] = useState<ListModel[]>([]);
  const [formTipos] = useState<ListModel[]>([
    { value: "3", label: "Sin Marcas" },
    { value: "4", label: "Planes Especiales" },
    { value: "44", label: "Internado" },
    { value: "5", label: "Hemodiálisis" },
  ]);
  const [showAlertMessage, setShowAlertMessage] = useState<boolean>(false);
  const [textAlertMessage, setTextAlertMessage] = useState<string>();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [practicasConvenio, setPracticasConvenio] = useState<
    ConvenioPractica[]
  >([]);
  const [practicasConvenioLookup, setPracticasConvenioLookup] = useState<
    ListModel[]
  >([]);
  const [practicaPrecio, setPracticaPrecio] = useState<number>(0);
  const [practicaCoseguro, setPracticaCoseguro] = useState<number>(0);
  const schema = yup
    .object()
    .shape({
      prescriptorId: yup.string().trim().required("Campo requerido"),
      afiliadoId: yup.string().trim().required("Campo requerido"),
      formBonoSerie: yup.string().trim(),
      formBonoNum: yup
        .string()
        .trim()
        .max(8, "8 Máximo")
        .required("Campo requerido"),
      formBonoSubNum: yup.string().trim(),
      formTipo: yup.string().trim().required("Campo requerido"),
      fechaPrescripcion: yup.date().required("Campo requerido"),
      fechaAutorizacion: yup.date().required("Campo requerido"),
      codigoDiagnosticoI: yup
        .string()
        .trim()
        .max(5, "5 Máximo")
        .required("Campo requerido"),
      codigoDiagnosticoII: yup.string().trim().max(5, "5 Máximo"),
      codigoDiagnosticoIII: yup.string().trim().max(5, "5 Máximo"),
      internacionNumero: yup.string().trim().max(6, "6 Máximo"),
      numeroValidacion: yup.string().trim().required("Campo requerido"),
      afiliadoDescripcion: yup.string().trim().required("Campo requerido"),
      convenioPracticaPrecioId: yup.string(),
    })
    .required();

  const {
    register,
    getFieldState,
    formState,
    handleSubmit,
    formState: { errors },
    setError,
    watch,
    control,
    setValue,
  } = useForm<PracticaSempre>({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const checkDisabledButton = () => {
    if (
      !watch("prescriptorId") ||
      !watch("afiliadoId") ||
      !watch("formBonoNum") ||
      !watch("formTipo") ||
      !watch("fechaPrescripcion") ||
      !watch("fechaAutorizacion") ||
      !watch("codigoDiagnosticoI") ||
      !watch("numeroValidacion") ||
      !watch("convenioPracticaPrecioId")
    )
      return true;

    return false;
  };

  const authInfo = useSelector<RootState, UserInfo>(
    ({ auth }: any) => auth.info,
    shallowEqual
  );

  const handleSubmitConfirmar = (data: any) => {
    if (authInfo.role === "PROFESIONAL" && authInfo.profesionalId) {
      // data.fechaPrescripcion.setHours(0, 0, 0, 0);
      // data.fechaAutorizacion.setHours(0, 0, 0, 0);
      // const practicas: any = [];
      const sempreData = {
        ...data,
        formTipo: watch("formTipo") === "44" ? "4" : watch("formTipo"),
        // valOnlineNumero: practica.valOnlineNumero,
        codigoPractica: practica.codigoPractica,
        coseguro: practicaCoseguro !== 0,
        cuit: practica.afiliadoCuil,
        numeroAfiliado: practica.afiliadoCuil,
        prestacionImpAcAfi: practicaCoseguro.toString(),
        profesionalFactura: practica.efectorCuil,
        profesionalRealiza: practica.efectorCuil,
        profesionalPrescribe: practica.prescriptorCuil,
      };
      const practicaToSave: any = {
        convenioPracticaPrecioId: watch("convenioPracticaPrecioId"),
        cantidad: practica.cantidad,
        fecha: practica.fechaConsumo,
        paciente: practica.afiliadoNombre,
        profesionalId: authInfo.profesionalId,
        precio: practicaPrecio,
        afiliadoCuil: practica.afiliadoCuil,
        coseguro: practicaCoseguro,
        prescriptorCuil: practica.prescriptorCuil,
        afiliadoDni: practica.afiliadoDni,
        practicaSempre: sempreData,
      };

      importacionSempreServices
        .confirmar(practicaToSave)
        .then((response: any) => {
          refetch();
          handleClose(true, response.data[0]);
        })
        .catch((error: any) => {
          if (error?.response?.status === 400) {
            handle400Error(error.response.data.errors, setError);
          } else {
            setTextAlertMessage(
              "No se pudo cargar la práctica. Intente nuevamente."
            );
            setShowAlertMessage(true);
          }
        });

      props.handleClose(true, data);
    }
  };

  const ActionsComponent = () => {
    return (
      <div className="button-precarga-action">
        <Button
          className="close-button"
          onClick={() => handleClose(false, null)}
        >
          Cancelar
        </Button>
        <Button
          className="create-button"
          variant="contained"
          onClick={handleSubmit((data) => handleSubmitConfirmar(data))}
          disabled={checkDisabledButton()}
        >
          Guardar
        </Button>
      </div>
    );
  };

  useEffect(() => {
    setFormBonoSeries(formBonos);
  }, []);

  useEffect(() => {
    if (practica) {
      setValue("prescriptorId", practica.prescriptorId, {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue("afiliadoId", practica.afiliadoId, {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue("fechaPrescripcion", practica.valOnlineFecha, {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue("fechaAutorizacion", practica.fechaAutorizacion, {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue("codigoDiagnosticoI", practica.diagnostico, {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue("numeroValidacion", practica.valOnlineNumero, {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue("afiliadoDescripcion", practica.afiliadoNombre, {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });

      if (formTipos)
        setValue("formTipo", "3", {
          shouldTouch: true,
          shouldDirty: true,
          shouldValidate: true,
        });

      // const formBonoSerie = ExtraerFormBonoSerie(practica.serieNumero);
      if (practica.serieNumero !== null && formBonos)
        setValue("formBonoSerie", practica.serieNumero, {
          shouldTouch: true,
          shouldDirty: true,
          shouldValidate: true,
        });

      // const formBonoNum = ExtraerFormBonoNum(practica.serieNumero);
      // if (formBonoNum !== null)
      setValue("formBonoNum", practica.prescripcionNumero.toString(), {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
      if (practica.convenioPracticaPrecioId !== null)
        setValue(
          "convenioPracticaPrecioId",
          practica.convenioPracticaPrecioId,
          {
            shouldTouch: true,
            shouldDirty: true,
            shouldValidate: true,
          }
        );
      else {
        getPracticasConvenio();
      }
      setPracticaPrecio(practica.precio);
      setPracticaCoseguro(practica.coseguro);
    }
  }, [practica, formBonos, formTipos]);

  useEffect(() => {
    if (watch("convenioPracticaPrecioId") !== null) {
      const practicaConvenio = practicasConvenio.find(
        (p) => p.convenioPracticaPrecioId === watch("convenioPracticaPrecioId")
      );
      if (practicaConvenio) {
        setPracticaPrecio(practicaConvenio.precio);
        setPracticaCoseguro(practicaConvenio.coseguro);
      }
    }
  }, [watch("convenioPracticaPrecioId")]);

  const getPracticasConvenio = async () => {
    // const fecha = new Date(practica.fechaConsumo.toString());
    // fecha.setHours(0, 0, 0, 0);
    const settings = await environment;
    console.log("env", environment);
    convenioServices
      .getPracticasByOs(
        settings.sempreId,
        practica.fechaConsumo,
        authInfo.profesionalId,
        practica.codigoPractica
      )
      .then((response) => {
        const items: ListModel[] = [];
        response.data.practicas.forEach((element: any) => {
          items.push({
            value: element.convenioPracticaPrecioId,
            label: formatPracticaDescription(
              element.numeroPractica,
              element.descripcion
            ),
          });
        });
        setPracticasConvenioLookup(items);
        setPracticasConvenio(response.data.practicas);
        setDisabled(false);
      })
      .catch((error) => {
        setDisabled(true);
      });
  };

  return (
    <CustomModal
      show={show}
      handleClose={() => handleClose(false, null)}
      title="Presentar Práctica SEMPRE"
      actions={<ActionsComponent />}
      size="lg"
    >
      <div className="precarga-modal">
        {showAlertMessage && (
          <div className="error-message">
            <Alert variant="outlined" severity="error">
              {textAlertMessage}
            </Alert>
          </div>
        )}

        <Box
          sx={{ height: 400, flexGrow: 1 }}
          component="form"
          autoComplete="off"
          //   onSubmit={handleSubmitAdd}
        >
          <div className="precarga-container">
            <Grid container spacing={2} rowSpacing={4}>
              <Grid size={6}>
                <TextField
                  id="afiliado_nombre"
                  label="Afiliado"
                  value={
                    practica?.afiliadoCuil + " - " + practica?.afiliadoNombre
                  }
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid size={3}>
                <TextField
                  id="val_online"
                  label="Número Validación Online"
                  value={practica?.valOnlineNumero}
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid size={3}>
                <TextField
                  id="fecha_autorizacion"
                  label="Fecha Autorización"
                  value={
                    practica.fechaAutorizacion
                      ? getFormattedDate(practica.fechaAutorizacion.toString())
                      : ""
                  }
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid size={3}>
                <TextField
                  id="codigo_practica"
                  label="Código Práctica"
                  value={practica?.codigoPractica}
                  variant="outlined"
                  disabled
                />
              </Grid>
              {practica.convenioPracticaPrecioId === null && (
                <Grid size={8}>
                  <AutocompleteSelect
                    name="convenioPracticaPrecioId"
                    label="Práctica"
                    isMultiple={false}
                    register={register}
                    getFieldState={getFieldState}
                    formState={formState}
                    errors={errors}
                    required={true}
                    options={practicasConvenioLookup}
                    // disabled={disabled}
                    onChange={(value) =>
                      setValue("convenioPracticaPrecioId", value, {
                        shouldTouch: true,
                        shouldDirty: true,
                        shouldValidate: true,
                      })
                    }
                  ></AutocompleteSelect>
                </Grid>
              )}
              {practica.convenioPracticaPrecioId !== null && (
                <Grid size={8}>
                  <TextField
                    id="nombre_practica"
                    label="Descripción"
                    value={practica?.nombrePractica}
                    variant="outlined"
                    disabled
                  />
                </Grid>
              )}

              <Grid size={1}>
                <TextField
                  id="cantidad"
                  label="Cantidad"
                  value={practica?.cantidad}
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid size={3}>
                <TextField
                  id="fecha_prescripcion"
                  label="Fecha Prescripción"
                  value={
                    practica.valOnlineFecha
                      ? getFormattedDate(practica.valOnlineFecha.toString())
                      : ""
                  }
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid size={3}>
                <TextField
                  id="valor"
                  label="Precio"
                  value={getFormattedDecimal(practicaPrecio)}
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid size={3}>
                <TextField
                  id="valor_total"
                  label="Precio Total (sin coseguro)"
                  value={getFormattedDecimal(practicaPrecio * practica?.cantidad)}
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid size={3}>
                <TextField
                  id="coseguro"
                  label="Coseguro (por cada práctica)"
                  value={getFormattedDecimal(practicaCoseguro)}
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid size={8}>
                <TextField
                  id="profesional_prescribe"
                  label="Profesional Prescriptor"
                  value={`${practica?.prescriptorCuil} ${practica?.prescriptorNombre ? ' - ' + practica?.prescriptorNombre : ''}`}
                  variant="outlined"
                  disabled
                />
              </Grid>
              <Grid size={12} container spacing={2} rowSpacing={4}>
                <Grid size={3}>
                  <Controller
                    name="formBonoSerie"
                    control={control}
                    render={({ field }) => (
                      <CustomSelect
                        field={field}
                        name="formBonoSerie"
                        label="Form. Bono Serie"
                        isMultiple={false}
                        register={register}
                        getFieldState={getFieldState}
                        formState={formState}
                        errors={errors}
                        required={true}
                        options={formBonoSeries}
                        value={watch("formBonoSerie")}
                      ></CustomSelect>
                    )}
                  />
                </Grid>
                <Grid size={3}>
                  <div className="input-color">
                    <CustomInput
                      name="formBonoNum"
                      label="Form. Bono Número"
                      type="number"
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={true}
                      max={9999999}
                      min={0}
                      value={watch("formBonoNum")}
                    ></CustomInput>
                  </div>
                </Grid>
                <Grid size={3}>
                  <div className="input-color">
                    <CustomInput
                      name="formBonoSubNum"
                      label="Form. Bono Sub Número"
                      type="number"
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={false}
                      max={9}
                      min={0}
                    ></CustomInput>
                  </div>
                </Grid>
                <Grid size={3}>
                  <Controller
                    name="formTipo"
                    control={control}
                    render={({ field }) => (
                      <CustomSelect
                        field={field}
                        name="formTipo"
                        label="Form. Tipo"
                        isMultiple={false}
                        register={register}
                        getFieldState={getFieldState}
                        formState={formState}
                        errors={errors}
                        required={true}
                        options={formTipos}
                        value={watch("formTipo")}
                      ></CustomSelect>
                    )}
                  />
                </Grid>
              </Grid>

              <Grid size={12} container spacing={2} rowSpacing={4}>
                <Grid size={3}>
                  <div className="input-color">
                    <CustomInput
                      name="codigoDiagnosticoI"
                      label="Código Diagnóstico I"
                      type="text"
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={true}
                      maxLength={5}
                    ></CustomInput>
                  </div>
                </Grid>
                <Grid size={3}>
                  <div className="input-color">
                    <CustomInput
                      name="codigoDiagnosticoII"
                      label="Código Diagnóstico II"
                      type="text"
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={false}
                      maxLength={5}
                    ></CustomInput>
                  </div>
                </Grid>
                <Grid size={3}>
                  <div className="input-color">
                    <CustomInput
                      name="codigoDiagnosticoIII"
                      label="Código Diagnóstico III"
                      type="text"
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={false}
                      maxLength={5}
                    ></CustomInput>
                  </div>
                </Grid>
                <Grid size={3}>
                  <div className="input-color">
                    <CustomInput
                      name="internacionNumero"
                      label="Número Internación"
                      type="text"
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={false}
                      maxLength={6}
                    ></CustomInput>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
          {/* {obrasSociales.length > 0 && fechaMaximaPractica && (
            <div className="row">
              <div className="w-20">
                <Controller
                  name="fecha"
                  control={control}
                  render={({ field }) => (
                    <DateInput
                      field={field}
                      name="fecha"
                      label="Fecha"
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={true}
                      value={field.value}
                      maxDate={fechaMaximaPractica}
                    ></DateInput>
                  )}
                />
              </div>
              <div className="w-80">
                <Controller
                  name="obraSocialId"
                  control={control}
                  render={({ field }) => (
                    <CustomSelect
                      field={field}
                      name="obraSocialId"
                      label="Obra Social"
                      isMultiple={false}
                      register={register}
                      getFieldState={getFieldState}
                      formState={formState}
                      errors={errors}
                      required={true}
                      options={obrasSociales}
                    ></CustomSelect>
                  )}
                />
              </div>
            </div>
          )}
          <div className="row w-100">
            <CustomInput
              name="paciente"
              label="Paciente"
              type="text"
              register={register}
              getFieldState={getFieldState}
              formState={formState}
              errors={errors}
              required={true}
              maxLength={250}
              disabled={disabled}
              assistiveText="Si es paciente de Sempre no es necesario completar"
            ></CustomInput>
          </div>

          <div className="row w-100">
            <div className="w-70">
              <AutocompleteSelect
                name="convenioPracticaPrecioId"
                label="Práctica"
                isMultiple={false}
                register={register}
                getFieldState={getFieldState}
                formState={formState}
                errors={errors}
                required={true}
                options={practicasConvenioLookup}
                disabled={disabled}
                onChange={(value) =>
                  setValue("convenioPracticaPrecioId", value, {
                    shouldTouch: true,
                    shouldDirty: true,
                    shouldValidate: true,
                  })
                }
              ></AutocompleteSelect>
            </div>
            <div className="w-30 flex">
              <CustomInput
                name="cantidad"
                label="Cantidad"
                type="number"
                register={register}
                getFieldState={getFieldState}
                formState={formState}
                errors={errors}
                required={true}
                max={90}
                min={1}
                disabled={disabled}
              ></CustomInput>
              <Button
                className="close-button"
                onClick={() => agregarPractica()}
                disabled={checkDisabledAgregar()}
              >
                Agregar
              </Button>
            </div>
          </div>

          {practicasToSave.length > 0 && (
            <div className="row w-100">
              <TableMui
                table={{
                  columns,
                  data: practicasToSave,
                  paginationTotalRows: practicasToSave.length,
                  pointerOnHover: true,
                  highlightOnHover: true,
                  // onRowClicked: handleView,
                  // noDataComponent: !fetching && noDataComponent,
                }}
                //   setQueryParams={undefined}
                //   queryParams={undefined}
              ></TableMui>
            </div>
          )} */}
        </Box>
      </div>
    </CustomModal>
  );
}

export default PracticaPresentarModal;
